import { ServiceType } from '@rover/constants/src/translations/service.constants';
import Boarding from '@rover/icons/svg/boarding.svg';
import Daycare from '@rover/icons/svg/daycare.svg';
import DropIn from '@rover/icons/svg/drop-in.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import Sitting from '@rover/icons/svg/sitting.svg';
import Walking from '@rover/icons/svg/walking.svg';
import { SERVICE_SLUG_PRIORITY } from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/SitterProfilePage';
import { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';

const isServiceType = (slug: string): slug is ServiceType =>
  (Object.values(ServiceType) as string[]).includes(slug);

const getSlugPriorityIndex = (slug: string): number => {
  if (!isServiceType(slug)) return SERVICE_SLUG_PRIORITY.length;
  const index = SERVICE_SLUG_PRIORITY.indexOf(slug);
  return index === -1 ? SERVICE_SLUG_PRIORITY.length : index;
};

const dedupeBySlug = (
  services: EnhancedPersonSitterProfileService[]
): EnhancedPersonSitterProfileService[] => {
  const seenSlugs = new Set<string>();
  return services.filter((service) => {
    if (seenSlugs.has(service.slug)) return false;
    seenSlugs.add(service.slug);
    return true;
  });
};

export const getUniqueServicesSortedByPriority = (
  services: EnhancedPersonSitterProfileService[]
): EnhancedPersonSitterProfileService[] => {
  const uniqueServices = dedupeBySlug(services);
  return [...uniqueServices].sort(
    (a, b) => getSlugPriorityIndex(a.slug) - getSlugPriorityIndex(b.slug)
  );
};

export const getSitterSlugFromWebUrl = (webUrl: string): string => {
  try {
    const { pathname } = new URL(webUrl, 'http://x');
    return pathname.split('/').filter(Boolean)[1] ?? '';
  } catch {
    return '';
  }
};

export const buildContactUrl = (contactUrl: string, locationSearch: string): string => {
  const searchParams = locationSearch.startsWith('?')
    ? locationSearch.substring(1)
    : locationSearch;
  if (!searchParams) return contactUrl;
  const separator = contactUrl.includes('?') ? '&' : '?';
  return `${contactUrl}${separator}${searchParams}`;
};

export const serviceIconToGraphic: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  'sitter-home': Boarding,
  'sitter-traveling': Sitting,
  homevists: DropIn,
  daycare: Daycare,
  walking: Walking,
  grooming: Grooming,
};
